import React, { useEffect, useState } from "react";
import { SectionContainer } from "../SectionContainer";
import { SubmenuControls } from "../SubmenuControls";

export const TechnoRisks = ({data, addressInfos, outlineCity, updateAddress, openMedia, selectedItem, onSelectItem}) => {
    return (
        <main className="main-container" aria-label="Zone de contenu principal">
            <div className="content">
                <SubmenuControls selectedItem={selectedItem} data={data} onSelectedItem={(itemId) => onSelectItem('risques-technologiques', itemId)}/>
                <div className="subcontent">
                    <SectionContainer
                        title={selectedItem.label}
                        openMedia={openMedia}
                        selectedItem={selectedItem}
                        addressInfos={addressInfos}
                        outlineCity={outlineCity}
                        updateAddress={updateAddress}
                    />
                </div>
            </div>
        </main>
    )
}